/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  DexTradeStatus,
  OpenPositionListItem,
} from 'api/types/httpsTypes/dex-trade';
import {} from 'viem';
import { twMerge } from 'tailwind-merge';
import { PendingSnipeDetails } from './PendingSnipeDetails';
import { ExecutedTradeDetails } from './ExecutedTradeDetails';
import { BlockedTradeDetails } from './BlockedTradeDetails';
import { useQuery } from '@tanstack/react-query';
import {
  dexTradeKeys,
  DexTradeService,
} from 'api/services/httpServices/DexTradeService';
import { LoaderDex } from '../../../components/alerts/Loader';
import { ErrorPageDex } from '../../../research/components/shared/Common';
import { useEffect, useState } from 'react';
import { usePositionUpdate } from 'api/hooks/usePositionUpdate';
import { useSelectedChain } from '../../../components/chains/getChains';

export function PositionDetails({ id }: { id: string }) {
  const [position, setPosition] = useState<OpenPositionListItem>();
  const selectedChain = useSelectedChain();
  const updatedPosition = usePositionUpdate(selectedChain);

  const {
    data: data,
    isLoading,
    error,
  } = useQuery({
    queryFn: () => DexTradeService.getPosition(id),
    queryKey: dexTradeKeys.getPosition(id),
  });

  useEffect(() => {
    if (data) {
      setPosition(data);
    }
  }, [data]);

  // update position with websocket
  useEffect(() => {
    if (!updatedPosition || !updatedPosition.p || !data) return;

    if (updatedPosition.p.id === position?.id) {
      setPosition((prev) => ({ ...prev, ...updatedPosition.p }));
    }
  }, [updatedPosition]);

  if (error) {
    return <ErrorPageDex />;
  } else if (isLoading || !position) {
    return (
      <div className="flex justify-center h-[500px] items-center">
        <LoaderDex />
      </div>
    );
  } else {
    return position.status === DexTradeStatus.cancelledByUserSettings ? (
      <BlockedTradeDetails position={position} />
    ) : !position.protocol ? (
      <PendingSnipeDetails position={position} />
    ) : (
      <ExecutedTradeDetails position={position} />
    );
  }
}

export function Wrapper(props: React.ComponentProps<'div'>) {
  return (
    <div
      {...props}
      className={twMerge(
        'flex flex-col xxs:gap-2 xxs:bg-dex-black-900 lg:bg-dex-black-900 xxs:px-2 lg:p-2',
        props.className
      )}
    />
  );
}
